import type { DialogSize } from './types'

// TODO: Review heights for the dialogs
export const DIALOG_SIZES: { [key: string]: DialogSize } = {
  small: { width: 40, height: 60 },
  medium: { width: 55.5, height: 70 },
  large: { width: 75, height: 95 },
}
